import type { StoreUser } from '../../../../services/authService';

export const getStoreDetailsNotificationRecipientUsers = (users: StoreUser[]): StoreUser[] => (
    users.filter((user) => {
        const role = (user.role || '').trim().toLowerCase();
        return role === 'owner' || role === 'manager';
    })
);
